export default __webpack_public_path__ + "static/media/hummer.0b4b3031.svg";